import React from "react";

export default function FundoAurora() {
  return (
    <div className="aurora" aria-hidden>
      <span className="blob blob--1"></span>
      <span className="blob blob--2"></span>
      <span className="blob blob--3"></span>
      <span className="blob blob--4"></span>
    </div>
  );
}
